import { ArrowUpRight, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV_LINKS } from "../lib/site";
import { scrollToId } from "../hooks/useSmoothScroll";

export const Footer = () => (
  <footer className="relative border-t border-[#2A2D34] bg-[#0A0C0F]" data-testid="footer">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 pb-28 sm:pb-16">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
        <div className="lg:col-span-5">
          <Logo />
          <p className="mt-6 text-2xl lg:text-3xl font-black uppercase tracking-tighter leading-none max-w-md">
            Grow bolder.<br /><span className="text-[#C6FF00]">Launch faster.</span>
          </p>
        </div>
        <div className="lg:col-span-4 lg:col-start-7">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8A939B] mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => scrollToId(l.id)}
                  data-testid={`footer-link-${l.id}`}
                  className="font-semibold uppercase tracking-tight text-white/80 hover:text-[#C6FF00] transition-colors"
                >
                  {l.label}
                </button>
              </li>
            ))}
            <li>
              <Link to="/blog" data-testid="footer-link-articles" className="font-semibold uppercase tracking-tight text-white/80 hover:text-[#C6FF00] transition-colors">
                Articles
              </Link>
            </li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#8A939B] mb-5">Connect</p>
          <button
            onClick={() => scrollToId("contact")}
            data-testid="footer-cta"
            className="group inline-flex items-center gap-2 text-white font-bold uppercase tracking-tight hover:text-[#C6FF00] transition-colors"
          >
            Book a call
            <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" strokeWidth={2.5} />
          </button>
          <a
            href="https://www.instagram.com/hughlaunch"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            aria-label="HughLaunch on Instagram"
            className="group mt-5 flex w-fit items-center gap-2 text-white font-bold uppercase tracking-tight hover:text-[#C6FF00] transition-colors"
          >
            <Instagram className="h-4 w-4 text-[#C6FF00]" strokeWidth={2.5} />
            Instagram
          </a>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-[#2A2D34] pt-8">
        <p className="text-sm text-[#8A939B] font-medium">© {new Date().getFullYear()} HughLaunch. All rights reserved.</p>
        <p className="mt-1 text-xs text-[#4B5563]" data-testid="footer-rebrand-note">HughLaunch — formerly Hugh Digital — brand strategy, web design &amp; client acquisition.</p>
        <div className="flex items-center gap-6">
          <p className="text-xs uppercase tracking-[0.25em] text-[#8A939B]">Results Driven · Client Focused</p>
        </div>
      </div>
    </div>
  </footer>
);
